export default __webpack_public_path__ + "static/Streak-40d05fe3d13c8e3c468acfae7e4681cb.jpg";